//
// $FlowFixMe
import styled, { css } from 'styled-components';
import { FlexRow } from '../../globals';
import theme from 'shared/theme';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  flex: 1 0 auto;
  padding: 0 24px 24px;
`;

export const Actions = styled(FlexRow)`
  margin-top: 24px;
  justify-content: center;

  button + button {
    margin-left: 8px;
  }
`;

export const Date = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.community.coolGrey};
  font-family: Lato;
  font-size: 14px;
  font-weight: 500;
`;

export const RemovePreviewButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  vertical-align: top;
  background-color: ${theme.community.indigo};
  color: ${theme.text.reverse};
  border: none;
  border-radius: 100%;
  outline: none;
  padding: 4px;
  max-height: 24px;
  max-width: 24px;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background-color: ${theme.warn.alt};
  }
`;

export const PreviewMedia = styled.div`
  position: relative;
  padding: 0;
  padding-bottom: 8px;
  border: 1px solid ${theme.bg.border};
  height: 200px;
  width: 200px;
  border-radius: 8px;
  margin-top: 13px;
  & + & {
    padding-top: 16px;

    ${RemovePreviewButton} {
      top: 16px;
    }
  }

  & > img {
    border-radius: 8px;
    max-width: 100%;
  }
`;

export const PhotoSizeError = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  padding: 8px 16px;
  width: 100%;
  background: ${theme.special.wash};
  border-top: 1px solid ${theme.special.border};
  margin-top: 5px;
  &:hover {
    cursor: pointer;

    p {
      color: ${theme.brand.default};
    }
  }

  p {
    font-size: 14px;
    line-height: 1.4;
    color: ${theme.special.default};
    max-width: calc(100% - 48px);
  }

  div {
    align-self: center;
  }
`;
